/**
 * 금일 0,3,6,9,12,15,18,21 시
 * 
 * ex) 2일 0시
 * 
 * 메뉴 > 5x5
 * 2일   3,6,9,12,15,18,21
 * 3일 0,3,6,9,12,15,18,21
 * 4일 0,3,6,9,12,15,18,21
 * 5일 0,3
 * 
 * 업데이트 시간 1,7,13,19
 * 
 * 실제
 * 1시 : 21~
 * 7시 : 3~
 * 13시 : 9~
 * 19시 : 15~
 * 
 * 사진 cwm/cwmsjp_00.png?0200a
 * ~ 24.png
 * 
 * http://www.imocwx.com/
 * 영상 cwm/cwm_sjp.gif?0200a
 */


/**
 * [날짜 데이터 생성]
 * DD : 오늘 날짜 + 3일
 * HH : 배열 [0,3,6,9,12,15,18,21]
 * 표출시간 : 현재시간 + 3시간
 * 마지막 시간 : = 처음 시작시간
 */

/**
 * 일본 파도 위성 데이터 IMOC 를 표출하는 로직
 */
let today = new Date();

/**
 * 날짜에 원하는 날짜 수 더하기
 * @param {dattime} date 
 * @param {int} days 
 * @returns datetime
 */
let addDays = function (date, days) {
    let calDate = new Date(date);
    calDate.setDate(date.getDate() + days);
    return calDate;
}

let day1 = addDays(today, 1);
let day2 = addDays(today, 2);
let day3 = addDays(today, 3);

/**
 * [imoc 사이트 시작시간 반환 로직]
 * 
 * @param {int} nowTime 
 * @returns int
 */
let minStrTime = function (nowTime) {
    if (nowTime >= 19) return 15;
    if (nowTime >= 13) return 9;
    if (nowTime >= 7) return 3;
    if (nowTime >= 1) return 21;
}

/**
 * 시간표 생성
 * imoc 이미지 업데이트 시간 1,7,13,19
 * 
 * 실제
 * 1시 : 21~ ,
 * 7시 : 3~ ,
 * 13시 : 9~ ,
 * 19시 : 15~ 
 * @param {int} nowTime 
 * @returns [timeList,lastTimeList]
 */
let genTime = function (nowTime) {
    //최소 15시 이상은 표출되어야함 
    let timeList = [];
    let lastTimeList = [];

    let startTime = minStrTime(nowTime);

    //첫 날 시작시간
    for (var i = startTime; i < 22; i = i + 3) {
        timeList.push(i);
    }
    //마지막 날 시간
    for (var i = 0; i <= startTime; i = i + 3) {
        lastTimeList.push(i);
    }

    return [timeList, lastTimeList];
}

//시작 날짜 시간, 끝 날짜 시간 배열 생성
let weatherTimeSet = genTime(today.getHours());

/**
 * 요일 글자 변환
 * @param {int} dayNumber 
 * @returns string "월"
 */
let transWord = function (dayNumber) {
    let dayWord = "";
    switch (dayNumber) {
        case 0: dayWord = "일";
            break;
        case 1: dayWord = "월";
            break;
        case 2: dayWord = "화";
            break;
        case 3: dayWord = "수";
            break;
        case 4: dayWord = "목";
            break;
        case 5: dayWord = "금";
            break;
        case 6: dayWord = "토";
            break;
    }
    return dayWord;
}

//weather DateTime DataSet
var weatherDTD =
    [
        {
            "month": today.getMonth() + 1
            , "day": today.getDate()
            , "word": transWord(today.getDay())
            , "time": weatherTimeSet[0]
        },
        {
            "month": day1.getMonth() + 1
            , "day": day1.getDate()
            , "word": transWord(day1.getDay())
            , "time": [0, 3, 6, 9, 12, 15, 18, 21]
        },
        {
            "month": day2.getMonth() + 1
            , "day": day2.getDate()
            , "word": transWord(day2.getDay())
            , "time": [0, 3, 6, 9, 12, 15, 18, 21]
        },
        {
            "month": day3.getMonth() + 1
            , "day": day3.getDate()
            , "word": transWord(day3.getDay())
            , "time": weatherTimeSet[1]
        }
    ];

/**
 * 숫자를 문자열로 변환하여 길이가 1인 경우 앞에 '0'을 붙여 반환
 * @param {int} num 
 * @returns string "00"
 */
function addZero(num) {
    return num < 10 ? '0' + num : num.toString();
}

let weatherDTDTextList = [];
let index = 0

for (var i = 0; i < 4; i++) {
    weatherDTD[i].time.forEach(function (hour) {
        weatherDTDTextList.push(
            {
                text: weatherDTD[i].month + "월 " + weatherDTD[i].day + "일 (" + weatherDTD[i].word + ") " + hour + "시",
                value: addZero(index)
            }
        );
        index++;
    });
}

let getWeatherDate = function () {
    return weatherDTDTextList;
}

export default { getWeatherDate };